import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * maximize Icon from Figma
 * @link [Figma](https://www.figma.com/design/bbV5fb5jWhJHEbAUH2cC9f/Matching?node-id=1433-70743)
 * */
const MaximizeIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path className="fill-current" d="M11.25 4.37476C11.25 4.5818 11.082 4.74966 10.875 4.74976C10.6679 4.74976 10.5 4.58186 10.5 4.37476V2.03027L7.39008 5.14014C7.24366 5.28655 7.00626 5.28649 6.85981 5.14014C6.71336 4.99369 6.71336 4.75631 6.85981 4.60986L9.9697 1.5H7.62448C7.41752 1.49984 7.24948 1.33201 7.24948 1.125C7.24948 0.917995 7.41752 0.750165 7.62448 0.75H10.875C11.082 0.7501 11.25 0.917955 11.25 1.125V4.37476Z" />;
    t1 = <path className="fill-current" d="M0.750029 7.62524C0.750029 7.4182 0.918007 7.25034 1.12503 7.25024C1.33214 7.25024 1.50003 7.41814 1.50003 7.62524L1.50003 9.96973L4.60992 6.85986C4.75634 6.71345 4.99374 6.71351 5.14019 6.85986C5.28664 7.00631 5.28664 7.24369 5.14019 7.39014L2.0303 10.5L4.37552 10.5C4.58248 10.5002 4.75052 10.668 4.75052 10.875C4.75052 11.082 4.58248 11.2498 4.37552 11.25L1.12503 11.25C0.918007 11.2499 0.750029 11.082 0.750029 10.875L0.750029 7.62524Z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={12} height={12} {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MaximizeIcon;